export default __webpack_public_path__ + "static/media/56.0837bbdf.jpg";